import { render, staticRenderFns } from "./user-menu.component.vue?vue&type=template&id=775c9ad8&scoped=true"
import script from "./user-menu.component.ts?vue&type=script&lang=ts&external"
export * from "./user-menu.component.ts?vue&type=script&lang=ts&external"
import style0 from "./user-menu.component.scss?vue&type=style&index=0&id=775c9ad8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775c9ad8",
  null
  
)

export default component.exports